import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import { tt } from "../../../../utils/i18n/i18n";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import NiceModal from "@ebay/nice-modal-react";
import PlanOptionModal from "../../../../components/modal/PlanOption/PlanOptionModal";
import React, { ReactNode, useMemo } from "react";
import KC_Separator from "../../../../designsystem/KC_Separator/KC_Separator";
import { KC_Sizes } from "../../../../designsystem/ds_commons";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import "./styles.scss";

interface Props {
  title: string;
  children: ReactNode[] | ReactNode;
  noGrid?: boolean;
}

export default function (props: Props) {
  const { accountToDisplay } = useAccountToDisplaySelector();

  const BUTTONS = useMemo(() => {
    return (
      <>
        <div className="d-none d-sm-block">
          <KC_Button
            size={KC_ButtonSize.Large}
            isUpsell={true}
            text={tt("upsell_premium_button")}
            onClick={() => NiceModal.show(PlanOptionModal)}
            className="px-3 d-flex"
          />
        </div>
        <div className="d-block d-sm-none w-100">
          <KC_Button
            size={KC_ButtonSize.Large}
            isUpsell={true}
            text={tt("upsell_premium_button")}
            onClick={() => NiceModal.show(PlanOptionModal)}
            className="px-3 d-flex"
          />
        </div>
      </>
    );
  }, []);

  const displayUpsell = useMemo(() => {
    return !accountToDisplay?.saasFeatures?.ip;
  }, [accountToDisplay]);

  const containerClassName = useMemo(() => {
    return props.noGrid ? "" : "upsell-grid";
  }, [props.noGrid]);

  if (!displayUpsell) {
    return null;
  }

  return (
    <div className="upsell">
      <div className="w-100 d-flex align-items-center flex-column flex-md-row">
        <div className="flex-grow-1 py-2">
          <KC_Heading2 text={props.title} className="text-upsell" />
        </div>
        {BUTTONS}
      </div>
      <KC_Separator size={KC_Sizes.sm} />
      <KC_Separator size={KC_Sizes.sm} />
      <div className={containerClassName}>{props.children}</div>
    </div>
  );
}
